import React from 'react';
import { getSiteViewportFullscreen } from '../../../selectors';
import styled from 'styled-components';
import { useSelector } from 'react-redux';

export const AdminSiteViewportContainerComponent = styled.div`
  background: white;
  border-radius: 4px;
  box-shadow: rgba(0, 0, 0, 0.3) 0px 6px 10px -5px,
    rgba(0, 0, 0, 0.07) 0px 0px 30px -3px;
  transition: height 180ms, width 180ms;
  position: relative;
  will-change: height width;
`;

AdminSiteViewportContainerComponent.displayName = 'AdminSiteViewportContainer';

export const AdminSiteViewportContainer = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(
  (props, ref): React.ReactElement => {
    const isFullScreen = useSelector(getSiteViewportFullscreen);

    const style: React.CSSProperties = isFullScreen
      ? { ...props.style, position: 'fixed', top: '0', left: '0' }
      : props.style || {};

    return <AdminSiteViewportContainerComponent ref={ref} {...props} />;
  },
);

AdminSiteViewportContainer.displayName = 'AdminSiteViewportContainer';
